require('./filter-view.component.scss');

class FilterViewController {
  constructor(
    $scope,
    CurrentFilterService,
    CurrentModelService,
    PermissionService,
    RouterService,
    LayoutService,
  ) {
    this.$scope = $scope;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.layout = LayoutService;
  }

  get filterBar() {
    return this.CurrentFilterService.filterBar;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get stat() {
    return this.filterData.filterData;
  }

  get activity() {
    return this.filterData.filterData;
  }

  get card() {
    return this.filterData.filterData;
  }

  showMenu() {
    return this.CurrentFilterService.panel !== 'catalog' && !this.layout.hideMenu;
  }
}

export const FilterViewComponent = {
  template  : require('./filter-view.component.html'),
  bindings  : {
    filterData: '<',
    maximizeFrame: '<',
    showFactsInfo: '<',
    loadMore: '<',
    clickToUse: '<?',
  },
  controller: FilterViewController,
};



// WEBPACK FOOTER //
// ./src/view/filter-view.component.js